// Title.styles.js

import styled from 'styled-components';

const Title2Footer = styled.h2`
    font-size: 1.5em;
    color: white;
    font-family: "Euclid";

    @media (max-aspect-ratio: 0.6/1) {
        font-size: 1.5em;
    }
`;

export default Title2Footer;
